import Swiper from './swiper-bundle.esm.browser.min.js';

class JklPromotionBanner extends HTMLElement {
  constructor() {
    super();
    
    this.swiper = null;
    this.sectionId = this.dataset.sectionId;
    this.autoplay = this.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5;
    this.mousewheel = this.dataset.mousewheel === 'true';
    this.slidesCount = parseInt(this.dataset.slidesCount, 10) || 0;
    
    this.swiperContainer = null;
    this.paginationEl = null;

    this.initSwiper = this.initSwiper.bind(this);
    this.handleSectionLoad = this.handleSectionLoad.bind(this);
    this.handleBlockSelect = this.handleBlockSelect.bind(this);
  }

  connectedCallback() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      requestAnimationFrame(() => this.init());
    }
  }

  init() {
    this.swiperContainer = this.querySelector('.jkl-promotion-banner__swiper');
    this.paginationEl = this.querySelector('.jkl-promotion-banner__pagination');

    if (!this.swiperContainer) return;
    
    if (this.slidesCount > 0) {
      this.initSwiper();
    }
    
    // Theme Editor events
    document.addEventListener('shopify:section:load', this.handleSectionLoad);
    document.addEventListener('shopify:block:select', this.handleBlockSelect);
  }

  initSwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    
    const swiperConfig = {
      // Mobile first: 1 slide
      slidesPerView: 1,
      spaceBetween: 16,
      speed: 500,
      
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
      
      // Mousewheel support
      mousewheel: this.mousewheel ? {
        forceToAxis: true,
      } : false,
      
      // Pagination dots (mobile only — hidden on desktop via CSS)
      pagination: this.slidesCount > 1 ? {
        el: this.paginationEl,
        clickable: true,
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
      } : false,

      // Autoplay
      autoplay: this.autoplay && this.slidesCount > 1 ? {
        delay: this.autoplaySpeed * 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      } : false,
      
      // Accessibility
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
      },
      
      // Observer for dynamic content
      observer: true,
      observeParents: true,
    };
    
    this.swiper = new Swiper(this.swiperContainer, swiperConfig);
    
    if (window.Shopify && window.Shopify.designMode) {
      console.log('[JKL Promotion Banner] Initialized', {
        slidesCount: this.slidesCount,
        autoplay: this.autoplay,
        mousewheel: this.mousewheel,
      });
    }
  }

  handleSectionLoad(event) {
    if (event.detail && event.detail.sectionId === this.sectionId) {
      setTimeout(() => this.init(), 100);
    }
  }

  handleBlockSelect(event) {
    if (event.detail && event.detail.sectionId === this.sectionId && this.swiper) {
      const blockId = event.detail.blockId;
      const slides = this.querySelectorAll('.swiper-slide');
      
      slides.forEach((slide, index) => {
        const card = slide.querySelector('[data-shopify-editor-block]');
        if (card && card.dataset.shopifyEditorBlock) {
          try {
            const blockData = JSON.parse(card.dataset.shopifyEditorBlock);
            if (blockData.id === blockId) {
              this.swiper.slideTo(index);
            }
          } catch (e) {
            console.error('Error parsing block data:', e);
          }
        }
      });
    }
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    
    document.removeEventListener('shopify:section:load', this.handleSectionLoad);
    document.removeEventListener('shopify:block:select', this.handleBlockSelect);
  }
}

if (!customElements.get('jkl-promotion-banner')) {
  customElements.define('jkl-promotion-banner', JklPromotionBanner);
}
